import { Tag, WImage, WLink } from '@components/atoms'
import { Ship } from '@components/icons'
import useTrans from '@hooks/useTrans'
import { GenericProdottoType } from '@utils/types'
import styles from './ProdottoCard.module.sass'

interface Props {
  className?: string
  item?: GenericProdottoType
  onClick?: () => void
}

const ProdottoCard = (props: Props) => {
  const { className = '', item = undefined, onClick = undefined } = props

  const t = useTrans()
  const classNames = `${styles.root} ${className}`
  const getContent = () => (
    <>
      <div className={styles.imageBox}>
        <WImage
          src={item.listingImage?.url}
          maxWidth={360}
          maxHeight={360}
          objectFit="cover"
          alt={item.listingImage?.imageAlt}
          title={item.title}
        />
        <div className={styles.containerTags}>
          {(item.quickShip || item.quickship) && (
            <Tag label={t('QuickShip')} className={styles.tag} icon={<Ship />} />
          )}
          {(item.new || item.novita) && <Tag label={t('Novità')} className={styles.tag} />}
        </div>
        {item.premio ? (
          <div className={styles.logoPremio}>
            <WImage
              maxWidth={80}
              maxHeight={80}
              src={item.premio}
              alt={item?.imageAlt}
              objectFit="contain"
            />
          </div>
        ) : item.brand?.logoTransparent ? (
          <div className={styles.logoBrand}>
            {item.isUsa ? (
              <img
                width={80}
                height={80}
                src={'/images/logo_made_in_usa_white.png'}
                style={{ objectFit: 'contain' }}
              />
            ) : (
              <WImage
                maxWidth={80}
                maxHeight={80}
                src={item.brand.logoTransparent}
                alt={item?.imageAlt}
                objectFit="contain"
              />
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className={styles.content}>
        {!!item.title && <h3 className={styles.title}>{item.title}</h3>}
      </div>
    </>
  )

  return item ? (
    item?.url ? (
      <WLink href={item?.url} className={classNames} ariaLabel={item.title} onClick={onClick}>
        {getContent()}
      </WLink>
    ) : (
      <div className={classNames}>{getContent()}</div>
    )
  ) : (
    <></>
  )
}

export default ProdottoCard
